const PREFIX = "[opublic-front]";
class LoggerService {
    constructor() {
        Object.defineProperty(this, "isDevelopment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.isDevelopment = !import.meta.env.PROD;
    }
    static getInstance() {
        if (!LoggerService.instance) {
            LoggerService.instance = new LoggerService();
        }
        return LoggerService.instance;
    }
    debug(message, context) {
        if (this.isDevelopment) {
            console.debug(`${PREFIX} ${message}`, context ?? "");
        }
    }
    info(message, context) {
        console.info(`${PREFIX} ${message}`, context ?? "");
    }
    warn(message, context) {
        console.warn(`${PREFIX} ${message}`, context ?? "");
    }
    error(message, context) {
        console.error(`${PREFIX} ${message}`, context ?? "");
    }
}
export const logger = LoggerService.getInstance();
